var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4V6L6.75 6.75M9.7725 8.2265C10.591 8.6685 11 8.89 11 9.25C11 9.61 10.591 9.8315 9.7725 10.2735L9.2155 10.574C8.587 10.9135 8.273 11.083 8.122 10.96C7.752 10.6575 8.3285 9.878 8.47 9.602C8.614 9.322 8.611 9.173 8.47 8.898C8.3285 8.622 7.752 7.8425 8.122 7.54C8.273 7.417 8.587 7.5865 9.2155 7.926L9.7725 8.2265Z",
    stroke: "#E4002B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.513 10.974C6.34433 10.991 6.17333 10.9997 6 11C3.2385 11 1 8.7615 1 6C1 3.2385 3.2385 1 6 1C8.7615 1 11 3.2385 11 6C10.9993 6.34333 10.966 6.67667 10.9 7",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.43e77053d6caf513a845fe65f0ea7ee8.svg";
export { ForwardRef as ReactComponent };